import React, { useRef, useState, useEffect } from "react";
import Trends from "../../assets/2 trend.webp";
import Sense from "../../assets/1 sense.webp";

const blogs = [
  {
    image: Sense,
    title: "Integrations",
    description: "7 Best Product Ideas For Online Selling in 2025",
  },
  {
    image: Trends,
    title: "Integrations",
    description: "7 Best Product Ideas For Online Selling in 2025",
  },
  {
    image: Sense,
    title: "Integrations",
    description: "7 Best Product Ideas For Online Selling in 2025",
  },
  {
    image: Trends,
    title: "Integrations",
    description: "7 Best Product Ideas For Online Selling in 2025",
  },
  {
    image: Sense,
    title: "Integrations",
    description: "7 Best Product Ideas For Online Selling in 2025",
  },
];

const OurBlog = () => {
  const desktopScrollRef = useRef(null);
  const tabletScrollRef = useRef(null);
  const mobileScrollRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState([]);
  const [screenSize, setScreenSize] = useState("desktop");
  const [autoScroll, setAutoScroll] = useState(true);


  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 1024) {
        setScreenSize("desktop");
      } else if (width >= 768) {
        setScreenSize("tablet");
      } else {
        setScreenSize("mobile");
      }
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🎯 Calculate visible cards dynamically
  useEffect(() => {
    let visiblePerView =
      screenSize === "desktop" ? 3 : screenSize === "tablet" ? 2 : 1;
    const visible = Array.from(
      { length: visiblePerView },
      (_, i) => (activeIndex + i) % blogs.length
    );
    setVisibleCards(visible);
  }, [activeIndex, screenSize]);

  // 🔄 Auto-scroll logic
  useEffect(() => {
    const interval = setInterval(() => {
      if (autoScroll) {
        scrollRight();
      }
    }, 2000); // Auto-scroll every 2 seconds

    return () => clearInterval(interval);
  }, [autoScroll, activeIndex]);

  const getCardsPerView = () =>
    screenSize === "desktop" ? 3 : screenSize === "tablet" ? 2 : 1;

  const getCurrentRef = () =>
    screenSize === "desktop"
      ? desktopScrollRef
      : screenSize === "tablet"
      ? tabletScrollRef
      : mobileScrollRef;

  // ▶ Scroll right
  const scrollRight = () => {
    const ref = getCurrentRef();
    if (ref.current) {
      const containerWidth = ref.current.clientWidth;
      const cardWidth = containerWidth / getCardsPerView();

      if (activeIndex >= blogs.length - 1) {
        ref.current.scrollTo({ left: 0, behavior: "smooth" });
        setActiveIndex(0);
      } else {
        ref.current.scrollBy({ left: cardWidth, behavior: "smooth" });
        setActiveIndex((prev) => prev + 1);
      }
    }
  };

  // ◀ Scroll left
  const scrollLeft = () => {
    const ref = getCurrentRef();
    if (ref.current) {
      const containerWidth = ref.current.clientWidth;
      const cardWidth = containerWidth / getCardsPerView();

      if (activeIndex === 0) {
        ref.current.scrollTo({
          left: ref.current.scrollWidth,
          behavior: "smooth",
        });
        setActiveIndex(blogs.length - 1);
      } else {
        ref.current.scrollBy({ left: -cardWidth, behavior: "smooth" });
        setActiveIndex((prev) => prev - 1);
      }
    }
  };

  // 🎮 Handle user interaction
  const handleUserInteraction = () => {
    setAutoScroll(false);
    setTimeout(() => setAutoScroll(true), 5000); // Resume auto-scroll after 5 sec
  };

  // 🔢 Scroll to specific index
  const scrollToIndex = (index) => {
    const ref = getCurrentRef();
    if (ref.current) {
      const containerWidth = ref.current.clientWidth;
      const cardWidth = containerWidth / getCardsPerView();
      const scrollPosition = index * cardWidth;
      ref.current.scrollTo({ left: scrollPosition, behavior: "smooth" });
      setActiveIndex(index);
    }
  };
  // 🖱️ Handle scroll events to update active index
  const handleScroll = () => {
    const ref = getCurrentRef();
    if (ref.current) {
      const scrollPosition = ref.current.scrollLeft;
      const containerWidth = ref.current.clientWidth;
      const cardWidth = containerWidth / getCardsPerView();

      const newIndex = Math.round(scrollPosition / cardWidth);

      if (
        newIndex !== activeIndex &&
        newIndex >= 0 &&
        newIndex < blogs.length
      ) {
        setActiveIndex(newIndex);
      }
    }
  };

  return (
    <div
      className="container-fluid py-1"
      style={{
        backgroundColor: "#ececec",
      }}
    >
      <div className="container px-0 pe-0 mb-4 position-relative">
        <div className="custom card body w-100 h-100 mt-5 p-3 ps-4 pe-0 gap-2 rounded-4 position-relative">
          <h1
            className=" fw-bold text-start mt-4 ml-8"
            style={{ color: "#444444",fontSize:"28px" }}
          >
            Discover Our Latest Blogs
          </h1>
          <p className="mt-0 text-start text-secondary fs-5 ml-8">
          Insights to Power Your Business Logistics
          </p>

          <div
            className="position-absolute d-none d-md-flex gap-2"
            style={{ top: "20px", right: "20px", zIndex: "1000" }}
          >
            <button
              className="btn btn-white rounded-circle d-flex justify-content-center align-items-center"
              style={{
                width: "50px",
                height: "50px",
                border: "1px solid #EAEAEC",
              }}
              onClick={scrollLeft}
            >
              <i className="fa-solid fa-arrow-left fs-3 text-black"></i>
            </button>

            <button
              className="btn btn-white rounded-circle d-flex justify-content-center align-items-center"
              style={{
                width: "50px",
                height: "50px",
                border: "1px solid #EAEAEC",
              }}
              onClick={scrollRight}
            >
              <i className="fa-solid fa-arrow-right fs-3 text-black"></i>
            </button>
          </div>

          <div className="container mt-0 p-0">
            {/* Desktop View (3 cards) */}
            <div
              className="d-none d-lg-flex overflow-hidden"
              ref={desktopScrollRef}
              style={{
                scrollBehavior: "smooth",
                gap: "20px",
                padding: "15px",
                margin: "0",
              }}
              onScroll={() => handleScroll(desktopScrollRef)}
            >
              {blogs.map((blog, index) => (
                <div
                  key={index}
                  className="card p-2 bg- #f7f7f8-subtle d-inline-block"
                  style={{
                    minWidth: "calc(100% / 3.3)",
                    maxWidth: "calc(100% / 3.3)",
                    borderRadius: "16px",
                    background: "#F7F7F8",
                    height: "380px",
                    border:
                      visibleCards.includes(index) && index === activeIndex
                        ? "2px solid #F97936"
                        : "none",
                    transition: "border 0.3s ease",
                  }}
                >
                  <img
                    src={blog.image}
                    className="card-img-top p-2"
                    alt={blog.title}
                    style={{
                      borderRadius: "20px",
                      objectFit: "cover",
                      width: "100%",
                      height: "200px",
                    }}
                  />
                  <div className="card-body1 p-3">
                    <h5 className="card-title1">
                      <span>{blog.title}</span>
                    </h5>
                    <p className="card-text1">{blog.description}</p>
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="fs-6 ml-2 font-sf-pro"
                        style={{
                          color: "#F97936",
                          cursor: "pointer",
                          marginTop: "-15px"
                        }}
                      >
                        Know More
                      </span>
                      <a
                        href="/"
                        className="d-flex justify-content-center align-items-center text-decoration-none"
                      >
                        <i
                          className="fa-solid fa-arrow-right"
                          style={{
                            color: "#F97936",
                            fontSize: "1.3rem",
                            marginTop: "-10px",
                          }}
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div
              className="d-none d-md-flex d-lg-none overflow-hidden"
              ref={tabletScrollRef}
              style={{
                scrollBehavior: "smooth",
                gap: "20px",
                padding: "15px",
                margin: "0",
              }}
              onScroll={() => handleScroll(tabletScrollRef)}
            >
              {blogs.map((blog, index) => (
                <div
                  key={index}
                  className="card p-2 bg- #f7f7f8-subtle d-inline-block"
                  style={{
                    minWidth: "calc(100% / 2.1)",
                    maxWidth: "calc(100% / 2.1)",
                    borderRadius: "16px",
                    background: "#F7F7F8",
                    height: "370px",
                    border:
                      visibleCards.includes(index) && index === activeIndex
                        ? "2px solid #F97936"
                        : "none",
                    transition: "border 0.3s ease",
                  }}
                >
                  <img
                    src={blog.image}
                    className="card-img-top p-4"
                    alt={blog.title}
                    style={{
                      borderRadius: "20px",
                      objectFit: "cover",
                      width: "100%",
                      height: "160px",
                    }}
                  />
                  <div className="card-body1 p-3">
                    <h5 className="card-title1">
                      <span>{blog.title}</span>
                    </h5>
                    <p className="card-text1">{blog.description}</p>
                    <div className="d-flex align-items-center mt-2 gap-2">
                      <span
                        className="fs-5 ml-2 font-sf-pro"
                        style={{
                          color: "#F97936",
                          cursor: "pointer",
                        }}
                      >
                        Know More
                      </span>
                      <a
                        href="/"
                        className="d-flex justify-content-center align-items-center text-decoration-none"
                      >
                        <i
                          className="fa-solid fa-arrow-right"
                          style={{
                            color: "#F97936",
                            fontSize: "1.3rem",
                            marginTop: "5px",
                          }}
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div
              className="d-flex d-md-none overflow-auto"
              ref={mobileScrollRef}
              style={{
                gap: "15px",
                scrollBehavior: "smooth",
                padding: "0",
                margin: "0",
                overflowX: "auto",
                scrollSnapType: "x mandatory",
              }}
              onScroll={() => handleScroll(mobileScrollRef)}
            >
              {blogs.map((blog, index) => (
                <div
                  key={index}
                  className="card p-2 bg-secondary-subtle d-inline-block"
                  style={{
                    minWidth: "100%",
                    maxWidth: "100%",
                    borderRadius: "16px",
                    height: "350px",
                    scrollSnapAlign: "start",
                    border:
                      index === activeIndex ? "2px solid #F97936" : "none",
                    transition: "border 0.3s ease",
                  }}
                >
                  <img
                    src={blog.image}
                    className="card-img-top p-2"
                    alt={blog.title}
                    style={{
                      borderRadius: "20px",
                      objectFit: "cover",
                      width: "100%",
                      height: "170px",
                    }}
                  />
                  <div className="card-body2">
                    <h5 className="card-title2">
                      <span className="bg-white rounded-5 px-3 p-2">
                        {blog.title}
                      </span>
                    </h5>
                    <p className="card-text2 text-secondary">
                      {blog.description}
                    </p>
                    <div className="d-flex align-items-center mt-2 gap-2">
                      <span
                        className="fs-5 ml-2 font-sf-pro"
                        style={{
                          color: "#F97936",
                          cursor: "pointer",
                        }}
                      >
                        Know More
                      </span>
                      <a
                        href="/"
                        className="d-flex justify-content-center align-items-center text-decoration-none"
                      >
                        <i
                          className="fa-solid fa-arrow-right"
                          style={{
                            color: "#F97936",
                            fontSize: "1.3rem",
                            marginTop: "6px",
                          }}
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="d-flex justify-content-center mt-3 mb-3 gap-2">
              {blogs.map((_, index) => (
                <button
                  key={index}
                  className="btn p-0 rounded-circle"
                  style={{
                    width: "12px",
                    height: "12px",
                    backgroundColor: activeIndex === index ? "#F97936" : "#ccc",
                    border: "none",
                    transition: "background-color 0.3s",
                  }}
                  onClick={() => scrollToIndex(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurBlog;
